import * as Yup from 'yup';
import { useSnackbar } from 'notistack5';
import { useFormik, Form, FormikProvider } from 'formik';
import { styled, alpha } from '@material-ui/core/styles';
// material
import { Stack, Card, TextField, Autocomplete, Box, Typography, Grid, Button } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
// utils
import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';
import apiUser from '../../../../api/user';
import apiPbx from '../../../../api/pbx';
import { useEffect, useState } from 'react';
// ----------------------------------------------------------------------
const ContentStyle = styled(Card)(({ theme }) => ({
  marginTop: -120,
  boxShadow: 'none',
  padding: theme.spacing(5),
  paddingTop: theme.spacing(16),
  color: theme.palette.common.white,
  backgroundImage: `linear-gradient(135deg,
    ${theme.palette.primary.main} 0%,
    ${theme.palette.primary.dark} 100%)`
}));
export default function SettingSip() {
  function isValidIPv4Address(ipAdress) {
    const ipv4Format = /^([0-9]{1,3}\.){3}[0-9]{1,3}$/;
    return ipv4Format.test(ipAdress);
  }
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [sipConfig, setSipConfig] = useState([]);
  const [sipSelected, setSipSelected] = useState({});

  useEffect(() => {
    const get_sip_config = async () => {
      try {
        const res = await apiPbx.find_sip_config();
        setSipConfig(res.data.data);
      } catch (error) {
        //enqueueSnackbar("Lấy thông tin SIP lỗi!", { variant: 'error' });
      }
    }
    get_sip_config();
    const get_sip_config_selected = async () => {
      try {
        const res = await apiPbx.find_sip_config_selected();
        setSipSelected(res.data.data);
      } catch (error) {
        //enqueueSnackbar("Lấy thông tin SIP lỗi!", { variant: 'error' });
      }
    }
    get_sip_config_selected();
  }, []);

  const editConfigSipSchema = Yup.object().shape({
    // configSIP: Yup.object().required("Thông tin tổng đài không được bỏ trống !")
    //
    // sipNumber: Yup.string().required('Số SIP không được bỏ trống !'),
    // sipPassword: Yup.string().required('Mật khẩu không được bỏ trống !')
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {

    },
    validationSchema: editConfigSipSchema,
    onSubmit: async (values, { setSubmitting }) => {
      const params = values?.configSIP;
      const isValid = isValidIPv4Address(params.ip_pbx);
      // if (isValid) {
        // const status_check_sip = await apiPbx.check_sip([
        //   {
        //     authentication: {
        //       sip: params.sip_number,
        //       password: params.sip_password,
        //       server: params.ip_pbx
        //     }
        //   }
        // ]);
        // if (status_check_sip.data.data && status_check_sip.data.status == 1000) {
          try {
            const res = await apiPbx.update_sip_config({ "ip_pbx": params.ip_pbx, "sip_number": params.sip_number, "is_select": params.is_select, "sip_password": params.sip_password});
            if (res.status == 200) {
              enqueueSnackbar("Cập nhật thông số SIP thành công !", { variant: 'success' });
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          } catch (error) {
            enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
          }
        // } else {
        //   enqueueSnackbar("Thông số SIP không đúng !!!", { variant: 'error' });
        // }
      // } else {
      //   enqueueSnackbar("Địa chỉ IP sai định dạng hoặc trường thông tin bị trống !!!", { variant: 'error' });
      // }

    }
  });
  // const resetFormChange = () => {
  //   formik.setFieldValue('ipPBX', '');
  //   formik.setFieldValue('sipNumber', '');
  //   formik.setFieldValue('sipPassword', '');
  // };

  const { errors, touched, isSubmitting, handleSubmit, getFieldProps, setFieldValue } = formik;

  const handleChangeIpPBX = (item) => {
    console.log(item);
    setFieldValue('configSIP', item);
  };
  const handleDisconnectPbx = async (ip_pbx, sip_number, user_id) => {
    try {
      const res = await apiPbx.disconnect_pbx({ "ip_pbx": ip_pbx, "sip_number": sip_number, "user_id": user_id });
      if (res.status == 200) {
        enqueueSnackbar(res.data.message[0], { variant: 'success' });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        // resetFormChange();
      }
    } catch (error) {
      enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
    }
  };
  const renderConfigSip = () => {
    if (sipConfig?.length != 0) {
      if (sipSelected?.is_select !== 1) {
        return (<>
          <Box
            component="img"
            src="/static/illustrations/illustration_invite.png"
            sx={{
              zIndex: 9,
              position: 'relative',
              left: 40,
              width: 140,
              filter: 'drop-shadow(0 12px 24px rgba(0,0,0,0.24))'
            }}
          />
          <ContentStyle>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Typography variant="h4">
                Vui lòng chọn tổng đài...
              </Typography>
              <Typography variant="h2">EXT: </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Typography variant="h6" sx={{ mt: 2, mb: 3 }}>
                <strong>IP Tổng đài: </strong>
              </Typography>
            </Stack>
            <Card sx={{ p: 3 }}>
              <div>

              </div>
              <FormikProvider value={formik}>
                <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                  <Stack spacing={3} alignItems="flex-end" sx={{ mt: 3 }}>
                    <Autocomplete
                      fullWidth
                      limitTags={1}
                      id="checkboxes-tags-demo"
                      name="configSIP"
                      options={sipConfig}
                      getOptionLabel={(option) => option.ip_pbx + " - " + option.sip_number}
                      onChange={(event, item) => handleChangeIpPBX(item)}
                      isOptionEqualToValue={(option, item) => option.ip_pbx === item.ip_pbx && option.sip_number === item.sip_number}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Chọn cấu hình tổng đài khác"
                          placeholder={t('options')}
                          {...getFieldProps('configSIP')}
                        />
                      )}
                    />
                    <LoadingButton startIcon={<Icon icon="codicon:save-as" />} type="submit" variant="contained" loading={isSubmitting}>
                      {t('save_changes')}
                    </LoadingButton>
                  </Stack>
                </Form>
              </FormikProvider>
            </Card>
          </ContentStyle>
        </>);
      } else {
        return (<div>
          {/* {sipConfig?.map((item, index) => { */}
            {/* if (item?.is_select == 1) { */}
              {/* return ( */}
                <>
                  <Box
                    component="img"
                    src="/static/illustrations/illustration_invite.png"
                    sx={{
                      zIndex: 9,
                      position: 'relative',
                      left: 40,
                      width: 140,
                      filter: 'drop-shadow(0 12px 24px rgba(0,0,0,0.24))'
                    }}
                  />
                  <ContentStyle>
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                      <Typography variant="h4">
                        Tổng đài đang hoạt động
                      </Typography>
                      <Typography variant="h2">EXT: {sipSelected?.sip_number}</Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                      <Typography variant="h6" sx={{ mt: 2, mb: 3 }}>
                        <strong>IP Tổng đài: </strong>{sipSelected?.ip_pbx}
                      </Typography>
                      <Button onClick={() => handleDisconnectPbx(sipSelected?.ip_pbx, sipSelected?.sip_number, sipSelected?.user_id)} variant="contained" color="error" startIcon={<Icon icon="fluent:plug-disconnected-28-filled" />}>
                        Ngắt kết nối
                      </Button>
                    </Stack>
                    <Card sx={{ p: 3 }}>
                      <div>

                      </div>
                      <FormikProvider value={formik}>
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                          <Stack spacing={3} alignItems="flex-end" sx={{ mt: 3 }}>
                            <Autocomplete
                              fullWidth
                              limitTags={1}
                              id="checkboxes-tags-demo"
                              name="configSIP"
                              options={sipConfig}
                              getOptionLabel={(option) => option.ip_pbx + " - " + option.sip_number}
                              onChange={(event, item) => handleChangeIpPBX(item)}
                              isOptionEqualToValue={(option, item) => option.ip_pbx === item.ip_pbx && option.sip_number === item.sip_number}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  label="Chọn cấu hình tổng đài khác"
                                  placeholder={t('options')}
                                  {...getFieldProps('configSIP')}
                                />
                              )}
                            />
                            <LoadingButton startIcon={<Icon icon="codicon:save-as" />} type="submit" variant="contained" loading={isSubmitting}>
                              {t('save_changes')}
                            </LoadingButton>
                          </Stack>
                        </Form>
                      </FormikProvider>
                    </Card>
                  </ContentStyle>
                </>
                {/* ); */}
            {/*  } */}
          {/* })} */}
        </div>);
      }

    } else {
      return (
        <>
          <Box
            component="img"
            src="/static/illustrations/illustration_invite.png"
            sx={{
              zIndex: 9,
              position: 'relative',
              left: 40,
              width: 140,
              filter: 'drop-shadow(0 12px 24px rgba(0,0,0,0.24))'
            }}
          />
          <ContentStyle>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Typography variant="h4">
                Chưa có tổng đài nào !!!
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Typography variant="h6" sx={{ mt: 2, mb: 3 }}>
                <strong>Vui lòng liên hệ Quản Lý của bạn hoặc Hỗ Trợ Kỹ Thuật</strong>
              </Typography>
            </Stack>
          </ContentStyle>
        </>
      );
    }
  };
  return (
    <>
      {renderConfigSip()}
    </>
    
    // <Grid container spacing={3}>
    //   <Grid item xs={12} md={3}>

    //   </Grid>
    //   <Grid item xs={12} md={6}>
    //     {renderConfigSip()}
    //   </Grid>

    //   <Grid item xs={12} md={3}>

    //   </Grid>
    // </Grid>
  );
}
